export const DEFAULT_LANGUAGE = "tr";

const SUPPORTED_LANGUAGES = ["tr", "ru", "ar"];

export function getDefaultLanguage() {
  if (
    typeof window !== "undefined" &&
    window.config &&
    window.config.defaultLanguage
  ) {
    return window.config.defaultLanguage;
  }

  return DEFAULT_LANGUAGE;
}

export function resolveLanguage(userLanguage) {
  const language = userLanguage || getDefaultLanguage();

  return SUPPORTED_LANGUAGES.includes(language) ? language : getDefaultLanguage();
}
